import React from 'react'
import { utils } from 'passiv-libs'
import { Modal } from 'passiv-components'

const renderPortal = ({ hotwater, display, inOut, away, hotwaterModal }) => {

  if (display === '' && !away.show) {
    utils.settings.setPortalWindowStatus(false)
  } else {
    utils.settings.setPortalWindowStatus(true)
  }


  return display === 'modal-tip-away'
    ? () => (
        <Modal
          {...away.modal.going}
          open={true}
          type="away"
          title="Away"
          buttons={away.modal.going.buttons}
        />
      )
    : display === 'modal-away-returning'
    ? () => (
        <Modal
          {...away.modal.returning}
          open={true}
          type="away"
          buttons={away.modal.returning.buttons}
        />
      )
    : display === 'modal-time'
    ? () => (
        <Modal
          open={true}
          type="mobiscroll"
          mobiscroll={inOut.timeModal.mobiscroll}
          title="Out"
          buttons={inOut.timeModal.buttons}
        />
      )
    : display === 'modal-tip-in'
    ? () => (
        <Modal
          {...inOut.tipModalIn}
          open={true}
          type="out"
          title="Home"
          buttons={inOut.tipModalIn.buttons}
        />
      )
    : display === 'modal-tip-out'
    ? () => (
        <Modal
          {...inOut.tipModalOut}
          open={true}
          type="out"
          title="Out"
          buttons={inOut.tipModalOut.buttons}
        />
      )
    : display === 'modal-tip-asleep'
    ? () => (
        <Modal
          {...inOut.tipModalAsleep}
          open={true}
          type="out"
          title="Asleep"
          buttons={inOut.tipModalAsleep.buttons}
        />
      )
    : display === 'modal-hot-water-1'
    ? () => {
        const text = (hotwater.settings.preStartLength !== hotwater.settings.fullHeatLength || hotwater.settings.reheatPeriod.from && hotwater.settings.reheatPeriod.to)
                      ? hotwaterModal.modal1.text + " This replaces some hot water settings and provides better flexibility."
                      : hotwaterModal.modal1.text
        return (<Modal
          {...hotwaterModal.modal1}
          text={text}
        />
      )}
      : display === 'modal-hot-water-2'
      ? () => {
          return (<Modal
            {...hotwaterModal.modal2}
          />
        )}
    : null
}

export default renderPortal
